import { alpha, GlobalStylesProps, Theme } from '@mui/material';

export const globalStyles: GlobalStylesProps['styles'] = (theme: Theme) => ({
    '#root, html': {
        margin: '0',
        height: '100%',
        width: '100%',
    },

    'html body': {
        'fontFamily': theme.fonts.primary,
        'margin': '0',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        'display': 'table',
        'height': '100%',
        'width': '100%',
        'overflow': 'hidden',
    },

    'body .Toastify__toast-container--top-center, body .Toastify__toast-container--top-right': {
        top: '117px',
        padding: '0',
        zIndex: 1,
        width: 'auto',
        overflow: 'hidden',
        [theme.breakpoints.down('sm')]: {
            top: '80px',
        },
    },

    'body .Toastify__toast-theme--dark': {
        fontFamily: theme.fonts.primary,
        fontSize: '1.3em',
        backgroundColor: alpha(theme.palette.background.default, 0.7),
        color: theme.palette.text.primary,
    },

    'body .Toastify__progress-bar-theme--dark': {
        backgroundColor: theme.palette.secondary.main,
    },

    'body .Toastify__close-button.Toastify__close-button--dark': {
        color: theme.palette.primary.main,
        paddingTop: '9px',
        paddingRight: '5px'
    },

    'body .Toastify__close-button.Toastify__close-button--dark > svg': {
        height: '28px',
        width: '24px',
        padding: '0'
    },

    'body .Toastify__toast': {
        'display': 'flex',
        'alignItems': 'center',
        'justifyContent': 'center',
        'borderRadius': 0,
        'paddingTop': '2px',
        'paddingBottom': '2px',
        '--toastify-toast-min-height': '50px',
        'minHeight': 'auto',
    },

    'body .Toastify__toast-body': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flex: '1 1 auto',
        padding: '8px 12px',
        width: '100%',
        whiteSpace: 'nowrap',
        gap: '0.5em',
    },

    '.mapboxgl-popup': {
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none',
        zIndex: theme.zIndex.appBar + 300,
    },

    '.mapboxgl-popup-content': {
        backgroundColor: 'transparent',
        padding: 0,
    },

    '.mapboxgl-popup-close-button': {
        display: 'none',
    },

    '.mapboxgl-popup-tip': {
        display: 'none',
    },

    '.mapboxgl-marker': {
        transform: 'translate(0, -100%)',
    },
});